import Vue from "vue";
import Router from "vue-router";
import store from '@/store'

import Home from "./views/home";
import Register from "./views/register";
import Login from "./views/login";
import Profile from "./views/profile";

import ChangePassword from "./views/change-password";
import EditRegistration from "./views/edit-registration";
import Forecasts from "./views/forecasts";
import Orders from "./views/orders";
import NewOrders from "./views/order-add";
import ManageAccount from "./views/manage-account";
import ProductionLinesList from "./views/production-lines-list";
import NewForecasts from "./views/forecasts-add";

import defaultLayout from "./layouts/side-nav-outer-toolbar";
//import simpleLayout from "./layouts/single-card";
import fullLayout from "./layouts/full-card";

Vue.use(Router);

const router = new Router({
  // mode:'history',
  // base:"/estamp-portal/",
  routes: [
    {
      path: "/home",
      name: "home",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: Home
      }
    },
    {
      path: "/production-lines-list",
      name: "production-lines-list",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: ProductionLinesList
      }
    }, 
    {
      path: "/orders",
      name: "orders",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: Orders
      }
    },
    {
      path: "/new-order",
      name: "new-order",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: NewOrders
      }
    },
    {
      path: "/forecasts",
      name: "forecasts",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: Forecasts
      }
    },
    {
      path: "/new-forecasts",
      name: "new-forecasts",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: NewForecasts
      }
    },
    {
      path: "/manage-account",
      name: "manage-account",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: ManageAccount
      }
    },
    {
      path: "/edit-registration",
      name: "edit-registration",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: EditRegistration  
      }
    },
    {
      path: "/change-password",
      name: "change-password",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: ChangePassword  
      }
    },
    {
      path: "/profile",
      name: "profile",
      meta: { requiresAuth: true },
      components: {
        layout: defaultLayout,
        content: Profile
      }
    },
    {
      path: "/register",
      name: "register",
      meta: { requiresAuth: true },
      components: {
        layout: fullLayout,
        content: Register  
      }
    },
    {
      path: "/login",
      name: "login",
      meta: { requiresAuth: true },
      components: {
        layout: fullLayout,
        content: Login  
      }
    },
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/recovery",
      redirect: "/home"
    },
    {
      path: "*",
      redirect: "/home"
    }
  ]
});

router.beforeEach((to, from, next) => {
  const publicPages = ['/login','/register']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = store.state.user.user
        
  if (authRequired && !loggedIn) {
    return next('/login')
  }

  next()
});

export default router;
